var _mask, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2049_1026",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05888 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05888 27.9411 0 18 0V4ZM18 0C8.05888 0 0 8.05888 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "white",
    mask: "url(#path-1-outside-1_2049_1026)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6654 24.167C24.6654 24.4403 24.4387 24.667 24.1654 24.667H11.832C11.5587 24.667 11.332 24.4403 11.332 24.167C11.332 23.8937 11.5587 23.667 11.832 23.667H24.1654C24.4387 23.667 24.6654 23.8937 24.6654 24.167Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2596 13.0132L13.0996 20.1732C12.8263 20.4465 12.3863 20.4465 12.1196 20.1732H12.113C11.1863 19.2398 11.1863 17.7332 12.113 16.8065L16.8796 12.0398C17.813 11.1065 19.3196 11.1065 20.253 12.0398C20.5263 12.2998 20.5263 12.7465 20.2596 13.0132Z",
    fill: "#667085"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8783 15.6602L21.845 13.6269C21.5717 13.3535 21.1317 13.3535 20.865 13.6269L13.705 20.7869C13.4317 21.0535 13.4317 21.4935 13.705 21.7669L15.7383 23.8069C16.6717 24.7335 18.1783 24.7335 19.1117 23.8069L23.8717 19.0402C24.8183 18.1069 24.8183 16.5935 23.8783 15.6602ZM18.505 21.6802L17.6983 22.4935C17.5317 22.6602 17.2583 22.6602 17.085 22.4935C16.9183 22.3269 16.9183 22.0535 17.085 21.8802L17.8983 21.0669C18.0583 20.9069 18.3383 20.9069 18.505 21.0669C18.6717 21.2335 18.6717 21.5202 18.505 21.6802ZM21.1517 19.0335L19.525 20.6669C19.3583 20.8269 19.085 20.8269 18.9117 20.6669C18.745 20.5002 18.745 20.2269 18.9117 20.0535L20.545 18.4202C20.705 18.2602 20.985 18.2602 21.1517 18.4202C21.3183 18.5935 21.3183 18.8669 21.1517 19.0335Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRounded);
export default __webpack_public_path__ + "static/media/card-rounded.3a3bc389feea16ca6333840cd7a203bd.svg";
export { ForwardRef as ReactComponent };